<template>
    <div class="pagination">
        <v-pagination
            color="rgba(50, 135, 54, 0.07)"
            light
            v-model="page"
            class="custom-pagination"
            :length="Math.ceil(total/perPage)"
            :total-visible="6"
            @input="$emit('changePage')"
        ></v-pagination>
    </div>
</template>

<script>
export default {
    name : "pagination",

    data() {
        return {
            page : 1
        }
    },

    props : {
        total : {
            type : Number,
            required : true
        },

        perPage : {
            type : Number,
            default : 20
        }
    },
}
</script>

<style lang="scss" scoped>

</style>

<style lang="scss">

.custom-pagination button {
     box-shadow: none;
}

.custom-pagination .v-pagination__item {
    background-color: transparent !important;
    color: var(--secondary-font) !important;
}

.custom-pagination .v-pagination__item.v-pagination__item--active, .custom-pagination .v-pagination__navigation {
    background-color: rgba(50, 135, 54, 0.07) !important;
    color: #328636 !important;
    font-weight: 500;

    & i {
        color: #328636 !important;
    }
}

</style>